<template>
  <div
    class="ds-control dsf-fast-form-layout ds-no-padding pc"
    :class="getCss"
    :style="{ 'background-color': backgroundColor }"
  >
    <div class="dsf-fast-form-layout_content" :columns="columns" slot-name="default">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfFastFormLayout",
  ctrlCaption: "快速表单布局",
  mixins: [$mixins.layout],
  provide() {
    return {
      $formLayoutBox: this
    };
  },
  props: {
    columns: {
      type: Number,
      default: 1
    },
    backgroundColor: {
      type: String,
      default: "#fff"
    },
    slots: {
      type: Array,
      default() {
        return [
          {
            name: "default",
            controls: []
          }
        ];
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    colSpan() {
      return 24 / this.columns;
    }
  },
  methods: {},
  design: {
    dragProxyStyle(mouseEnterTag, position) {
      //如果鼠标碰触的不是当前本身，则表示可能碰触了当前组件中已有的子组件
      if (mouseEnterTag != this) {
        let el = mouseEnterTag?.$layoutTree?.$el;
        if (el) {
          const width = el.offsetWidth,
            height = 4;
          let { top, left } = $(el).position();
          const { unitSize } = dsf;
          const style = {
            position: "absolute",
            width: unitSize(width),
            left: unitSize(left),
            height: unitSize(height),
            "background-color": "red",
            "border-style": "solid"
          };
          if (position == "after") {
            top += el.offsetHeight - height;
          }
          style.top = unitSize(top);
          return style;
        }
      }
    }
  }
});
</script>